/**
 * Module-level flag that CameraCaptureDialog sets on mount + clears on
 * unmount. Used by {@see useCameraPreviewGlobalCleanup} to skip its
 * defensive stop() call while the dialog is alive — otherwise the
 * global cleanup races against the in-dialog appStateChange handler:
 * BOTH fire CameraPreview.stop() on app resume, the two stop Runnables
 * interleave with the in-dialog start() Runnable on the UI thread,
 * and the plugin crashes with
 *
 *   NullPointerException: ...CameraActivity.setRect(...) on a null object reference
 *
 * because one of the two stop callbacks nulls the fragment field
 * between the start handler's `fragment = new CameraActivity()` and
 * its `fragment.setRect(...)` UI-thread Runnable.
 *
 * Captured in the device dropbox (build 20 + 24) from a Samsung A16 5G.
 */
let dialogMounted = 0

export function markCameraDialogMounted() {
  dialogMounted += 1
}

export function markCameraDialogUnmounted() {
  dialogMounted = Math.max(0, dialogMounted - 1)
}

export function isCameraDialogMounted(): boolean {
  return dialogMounted > 0
}
